/**
 *
 * Collection of titles.
 */
(function(Backbone, EG, _) {
  'use strict';

  EG.Users.Profile.Models.Title = EG.Users.Models.Base.extend({
    defaults: {
      code: '',
      label: '',
      selected: false,
    },
  });

  EG.Users.Profile.Collections.Title = EG.Users.Collections.Base.extend({
    model: EG.Users.Profile.Models.Title,
    isValidationRequired: false,
    setSelectedTitle: function(titleCode) {
      var model = this.findWhere({ code: titleCode });
      if (model) {
        model.set('selected', true);
      }
    },
  });

  /** This function adds validations for Airline Title
   * @returns the object with validation and error message
   *
   */
  function applyAirlineTitleValidations(){
    var airlineTitleValidations = [];
    airlineTitleValidations.push({
      required: true,
      msg: 'field_validation_required'
    });
    airlineTitleValidations.push({
      min: "1",
      msg: 'field_validation_required'
    });
    return airlineTitleValidations;
  }

  EG.Users.Profile.Collections.Title.applyAirlineTitleValidations = applyAirlineTitleValidations;
})(Backbone, EG, _);
